import { z } from 'zod';
import { WalletSchema } from '../wallet';

const wallet = WalletSchema.data.pick({ currency: true });

export const transactionWalletSchema = wallet.extend({
  /** the wallet Id */
  _id: WalletSchema.model.shape._id,
  /** the wallet holder name */
  holderName: WalletSchema.data.shape.holder.shape.name,
  /** the wallet balance `AFTER` making the transaction*/
  balance: WalletSchema.data.shape.balance,
  /** the wallet currency */
  currency: WalletSchema.data.shape.currency,
  /** the wallet holder Id, such as (user Id, business Id, carrier Id, driver Id, etc) */
  holderId: WalletSchema.data.shape.holder.shape._id,
  /** the wallet holder type */
  holderType: WalletSchema.data.shape.holder.shape.type,
  /** holder user id */
  holderUserId: WalletSchema.data.shape.holder.shape.userId,
});
export type TransactionWallet = z.infer<typeof transactionWalletSchema>;
